 
export class RegexConstants {
  /**
   * Same regex as C# code, but removed ftp and unicode characters.
   * If you need to add flags, use
   * ```
   * new RegExp(RegexConstants.URL, '<<flags>>')
   * ```
   *
   * @static
   * @memberof RegexConstants
   * @see https://github.com/microsoft/referencesource/blob/f461f1986ca4027720656a0c77bede9963e20b7e/System.ComponentModel.DataAnnotations/DataAnnotations/UrlAttribute.cs#L46
   */
  public static URL =
    /^(https?):\/\/(((([a-z]|\d|-|\.|_|)|(%[\da-f]{2})|[!$&'()*+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d)|(([a-z]|\d)([a-z]|\d|-|\.|_|~)*([a-z]|\d)))\.)+(([a-z])|(([a-z])([a-z]|\d|-|\.|_|~)*([a-z])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~)|(%[\da-f]{2})|[!$&'()*+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~)|(%[\da-f]{2})|[!$&'()*+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~)|(%[\da-f]{2})|[!$&'()*+,;=]|:|@)|\/|\?)*)?(#((([a-z]|\d|-|\.|_|~)|(%[\da-f]{2})|[!$&'()*+,;=]|:|@)|\/|\?)*)?$/

  /**
   * Routing hint only, never validation (that is `TAG_CODE_RULES.Stamped`). Recognizes a
   * stamped-looking code typed into the main-host QR box, so the user can be sent to the
   * stamped-tag flow: a 3-letter prefix, then 1 to 12 letters, digits or hyphens with at least one
   * digit (e.g. `ABC27-123`). The digit keeps junk single-segment paths such as `/scan` from
   * being redirected; a stamped code with no digit gets the generic warning instead.
   *
   * @static
   * @memberof RegexConstants
   */
  public static STAMPED_CODE_HINT = /^[A-Za-z]{3}(?=[A-Za-z0-9-]*\d)[A-Za-z0-9-]{1,12}$/

  /**
   * The paw-f.com hosts. A first load on them enters the stamped-tag flow (see
   * `router/tag-route-guard.ts`).
   *
   * @static
   * @memberof RegexConstants
   */
  public static PAW_F_HOST = /^(www\.)?paw-f\.com$/i
}
